import { render } from "./DesignEdit.vue?vue&type=template&id=267daf2f"
import script from "./DesignEdit.vue?vue&type=script&lang=js"
export * from "./DesignEdit.vue?vue&type=script&lang=js"

import "./DesignEdit.vue?vue&type=style&index=0&id=267daf2f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__